module.exports = __webpack_public_path__ + "static/94-735f7d9d5fc277ac8d612e4b0e744af6.png";